import React from 'react'
import './styles/MetarDetailSection.css'
import classnames from 'classnames'

const MetarDetailSection = props => {
  return (
    <div className={classnames("metarDetailSection", props.className)}>
      <div className="metarDetailSectionTitle">
        {props.title}
      </div>
      <div className="metarDetailSectionContent">
        {props.children}
      </div>
    </div>
  )
}

export default MetarDetailSection



// WEBPACK FOOTER //
// ./src/components/MetarDetailSection.js